"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SolutionDetailsLayout = exports.SolutionDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var main_aside_1 = require("../elements/main-aside");
var entity_value_1 = require("./entity-value");
var link_1 = require("../elements/link");
var entity_link_value_1 = require("./entity-link-value");
var entity_list_1 = require("./entity-list");
var quote_row_1 = require("./quote-row");
var entity_list_section_1 = require("./entity-list-section");
var grid_1 = require("../elements/grid");
var action_link_1 = require("../elements/action-link");
var use_lang_1 = require("../../hooks/use-lang");
var impact_result_row_1 = require("./impact-result-row");
var file_asset_value_1 = require("./file-asset-value");
exports.SolutionDetailsLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", ";\n  "], ["\n    padding: ", " ", " ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.H_DOT_BG_END())
});
var ActionLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(15))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var LinkValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ContactStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), LinkValueStyles),
  Contact: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ContactStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ActionLink: (0, styled_components_1.default)(action_link_1.ActionLink)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ActionLinkStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
};
var SolutionDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    banner = props.banner;
  var description = entity.description,
    benefits = entity.benefits,
    innovationType = entity.innovationType,
    quotes = entity.quotes,
    stage = entity.stage,
    results = entity.results,
    challenges = entity.challenges,
    _a = entity.files,
    files = _a === void 0 ? [] : _a,
    _b = entity.locations,
    locations = _b === void 0 ? [] : _b,
    contact = entity.contact,
    url = entity.url,
    targetMarket = entity.targetMarket;
  var t = (0, use_lang_1.useLang)();
  var hasDescription = description && description.text;
  var hasQuotes = !!quotes.length;
  var hasBenefits = !!benefits.length;
  var hasResults = !!results.length;
  var hasChallenges = !!challenges.length;
  var hasTargetMarket = !!targetMarket;
  var hasStage = !!stage;
  var hasInnovationType = !!innovationType;
  var hasLocations = !!locations.length;
  var hasNarratives = hasQuotes || hasBenefits || hasResults;
  var hasRelated = hasChallenges || hasTargetMarket || hasStage || hasInnovationType;
  var hasAside = asideHeader || asideFooter || contact || !!locations.length || hasRelated;
  return react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(My.MainAside, {
    main: react_1.default.createElement(My.Main, null, mainHeader, react_1.default.createElement(My.Section, null, hasDescription && react_1.default.createElement(My.Description, {
      maxWords: 100,
      entity: description
    }), url && react_1.default.createElement(My.ActionLink, {
      target: "_blank",
      invert: true,
      href: url
    }, t('View source article'))), react_1.default.createElement(My.ListSection, {
      variant: 'large',
      rowComponent: file_asset_value_1.FileAssetValue,
      showDividers: true,
      title: "Related Files:",
      items: files,
      maxItems: 3
    }), hasNarratives && react_1.default.createElement(My.Section, {
      title: "Narratives:"
    }, react_1.default.createElement(My.List, {
      showDividerForLast: hasResults,
      useLinks: false,
      showDescription: true,
      items: benefits,
      namePath: "type.name"
    }), react_1.default.createElement(My.List, {
      rowComponent: impact_result_row_1.ImpactResultRow,
      useLinks: false,
      showDescription: true,
      namePath: "type",
      items: results
    }), react_1.default.createElement(My.List, {
      rowComponent: quote_row_1.QuoteRow,
      items: quotes
    })), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, hasLocations && react_1.default.createElement(My.Section, {
      title: "Places:"
    }, react_1.default.createElement(My.List, {
      items: locations
    })), contact && react_1.default.createElement(My.Section, null, react_1.default.createElement(My.Contact, {
      entity: contact,
      label: "Primary Contact"
    })), hasRelated && react_1.default.createElement(My.Section, null, innovationType && react_1.default.createElement(My.Value, {
      entity: innovationType
    }), stage && react_1.default.createElement(My.Value, {
      entity: stage
    }), targetMarket && react_1.default.createElement(My.Value, {
      entity: targetMarket
    }), react_1.default.createElement(My.List, {
      items: challenges
    })), asideFooter)
  }));
};
exports.SolutionDetailsLayout = SolutionDetailsLayout;
exports.SolutionDetailsLayout.defaultProps = exports.SolutionDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;